// App.tsx
import React, {useEffect, useRef, useState} from "react";
import {Alert, message, Modal} from "antd";
import {useSnapshot} from "valtio/index";
import {HistoryItem, sseStore} from "@/utils/store/store";
import Markdown from "react-markdown";
import markdownDocx, {Packer} from 'markdown-docx';
import EmptyR from "@/pages/Index/static/ReadyGen.png";
import {ERROR_MESSAGES, SUCCESS_MESSAGES} from '@/constants/messages';
import {copyToClipboard, handleError, handleSuccess} from '@/utils/helpers';
import {estimateExecutionTime, estimateExecutionTimeByTemplate} from '@/utils/result-time-map';
import copy from "@/pages/Index/static/copy.png";
import exportP from "@/pages/Index/static/export.png";
import msg from "@/pages/Index/static/msg.png";

const History = ({historyItem}: { historyItem: HistoryItem | undefined }) => {
    const [editData, setEditData] = useState<string>("");
    const [editAble, setEditAble] = useState<boolean>(false);
    const {trace, data, loading, error, params} = useSnapshot(sseStore);
    const textareaRef = useRef<HTMLDivElement>(null);
    
    // 进度条相关状态
    const [progress, setProgress] = useState<number>(0);
    const [progressMax, setProgressMax] = useState<number>(100);
    const [remainingTime, setRemainingTime] = useState<number>(0);

    const isNotInHistory = historyItem === undefined;

    const fData = isNotInHistory ? data : JSON.parse(historyItem?.result)["default"]


    const handleExport = async () => {
        try {
          // Convert to docx
          const doc = await markdownDocx(fData);
          // Generate blob for download
          const blob = await Packer.toBlob(doc);

          // Create download link
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'document.docx';
          a.click();

          // Clean up
          URL.revokeObjectURL(url);
        } catch (error) {
            handleError(error, ERROR_MESSAGES.DOCX_GENERATION_FAILED);
        }
    };

    useEffect(() => {
        setEditData(data);
        if (isNotInHistory && textareaRef.current) {
            const element = textareaRef.current;
            element.scrollTop = element.scrollHeight;
        }

    }, [data]);
    
    /**
     * 处理进度条逻辑的useEffect
     * 当loading状态改变时，计算预估时间并启动进度条动画
     * 使用useRef存储interval引用，避免闭包问题
     */
    const intervalRef = useRef<NodeJS.Timeout | null>(null);
    
    useEffect(() => {
        if (loading && params?.Content) {
            // 计算字符数和预估时间，直接作为进度条最大值
            const wordCount = params.Content.length;
            const estimatedSeconds = estimateExecutionTimeByTemplate(wordCount, params.Output_type || '');
            setProgressMax(estimatedSeconds);
            setRemainingTime(estimatedSeconds);
            setProgress(0);
            
            // 启动进度条动画，每秒增长1
            intervalRef.current = setInterval(() => {
                setProgress(prev => {
                    const newProgress = prev + 1;
                    
                    // 更新剩余时间
                    setRemainingTime(prevTime => Math.max(0, prevTime - 1));
                    
                    // 达到预估时间后停止增长并清理interval
                    if (newProgress >= estimatedSeconds) {
                        if (intervalRef.current) {
                            clearInterval(intervalRef.current);
                            intervalRef.current = null;
                        }
                        return estimatedSeconds;
                    }
                    return newProgress;
                });
            }, 1000); // 每秒更新一次
        } else {
            // loading结束时重置进度条
            setProgress(0);
            setProgressMax(100);
            setRemainingTime(0);
        }
        
        // 清理函数确保interval被正确清理
        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [loading, params?.Content]);

    

    // @ts-ignore
    return (
        <>
            {/* 状态展示区域 */}
            <div className="shadow-2xs border-gray-200 card bg-white rounded-2xl responsive-result flex-shrink-0 flex flex-col">
                <div className="card-body p-4 overflow-y-auto overflow-x-clip flex-1 flex flex-col">

            <span className="grid grid-cols-8 gap-2">
                <div className=" col-span-4 flex flex-row gap-2.5">
                    {/*<LiaEditSolid  className="text-xl text-[#4B5563] object-contain font-thin"  />*/}

                  <img
                    src={copy}
                    className="w-5 h-5
                    object-contain font-thin transition duration-150 ease-in-out hover:-translate-y-0.5 hover:scale-110 hover:cursor-pointer
                    "
                    onClick={() => {
                      if (fData === "" || fData === undefined) {
                        message.info('内容为空').then(() => {
                        });
                        return;
                      }
                      copyToClipboard(fData, SUCCESS_MESSAGES.COPY_SUCCESS)
                    }}
                    style={{ opacity: 0.8 }}
                  />

                  <img
                    src={exportP}
                    className="w-5 h-5
                    object-contain font-thin transition duration-150 ease-in-out hover:-translate-y-0.5 hover:scale-110 hover:cursor-pointer
                    "
                    onClick={() => {
                      if (fData === "") {
                        message.info('内容为空').then(() => {
                        });
                        return;
                      }
                      handleExport().then(r => handleSuccess(SUCCESS_MESSAGES.DOCX_DOWNLOAD_SUCCESS))
                    }}
                    style={{ opacity: 0.8 }}
                  />







                    {
                        isNotInHistory ?
                            <label className={"w-22 pl-0.5 fieldset-label h-[20px] transition duration-150 ease-in-out hover:-translate-y-0.5 hover:scale-102"}>
                                <input
                                    onChange={event => {
                                        // console.log(1, event.target.checked);
                                        setEditAble(event.target.checked);
                                    }}
                                    // disabled={!data || loading}
                                    type="checkbox" className="toggle toggle-xs border-0 bg-[#F6F7FC] w-9 "/>
                                可编辑
                            </label>
                            : <></>
                    }


                </div>
              <button
                  onClick={() => window.open("https://wj.qq.com/s2/19205380/fe25/")}
                  className="text-[#727183] font-normal col-span-3 w-4/5 col-end-9 btn btn-sm text-sm p-0.5 h-[22px] text-[10px] border-0 rounded-full justify-self-end">
                <img
                          src={msg}
                          className="w-4 h-4"
                        />
                内测反馈问卷</button>
            </span>

            {/*<span className="card p-2 mt-2 bg-gray-100">*/}
            {/*  <div className={"flex space-x-4"}>*/}
            {/*     <button className="shrink  btn btn-xs btn-neutral w-14"*/}
            {/*             onClick={() => {*/}
            {/*                 if (fData === "" || fData === undefined) {*/}
            {/*                     message.info('内容为空').then(() => {*/}
            {/*                     });*/}
            {/*                     return;*/}
            {/*                 }*/}
            {/*                 copy(fData)*/}
            {/*                 message.info('复制成功').then(() => {*/}
            {/*                 });*/}
            {/*             }}*/}
            {/*     >复制</button>*/}
            {/*    <button className="shrink  btn  btn-xs btn-neutral w-14"*/}
            {/*            onClick={() => {*/}
            {/*                if (fData === "") {*/}
            {/*                    message.info('内容为空').then(() => {*/}
            {/*                    });*/}
            {/*                    return;*/}
            {/*                }*/}
            {/*                handleExport().then(r => message.info('导出成功').then(() => {}))*/}
            {/*                // copy(editData)*/}

            {/*            }}*/}
            {/*    >导出</button>*/}
            {/*      {*/}
            {/*          isNotInHistory ?*/}
            {/*              <label className={"w-24 fieldset-label"}>*/}
            {/*                  <input*/}
            {/*                      onChange={event => {*/}
            {/*                          // console.log(1, event.target.checked);*/}
            {/*                          setEditAble(event.target.checked);*/}
            {/*                      }}*/}
            {/*                      // disabled={!data || loading}*/}
            {/*                      type="checkbox" className="toggle toggle-sm p-1 "/>*/}
            {/*                  可编辑*/}
            {/*              </label>*/}
            {/*              : <></>*/}
            {/*      }*/}
            {/*  </div>*/}
            {/*</span>*/}


                    {error && (
                        <Alert
                            message="错误提示"
                            description={error.message}
                            type="error"
                            showIcon
                            closable
                            style={{marginBottom: 10}}
                        />
                    )}

                    {fData ?
                        (
                            editAble
                                ?
                                <textarea className="textarea w-[100%] h-full" value={editData}
                                          onChange={(dat) => {
                                              setEditData(dat.target.value);
                                          }}>
                                </textarea>
                                :
                                <article
                                    ref={textareaRef}
                                    // 如果不是md，需要text-wrap whitespace-pre-wrap
                                    className="markdown space-y-2 text-black overflow-y-auto flex-1">
                                    {/*<p>{data}</p>*/}
                                    <Markdown>
                                        {fData}
                                        {/*{data || '无内容'} // 处理空值情况*/}
                                    </Markdown>
                                </article>

                        )
                        : <div></div>
                    }

                    {
                        !loading && !fData &&
                        <div className={"pt-40 flex flex-col items-center justify-center align-middle text-center"}>
                            <img
                                src={EmptyR}
                                className="w-42 h-48 pt-10 ml-10 "
                                style={{  }}
                            />
                            <p className={"text-[#4B5563] p-2"}>等待发起整理</p>
                        </div>
                    }

                    {loading && fData && (
                        <div style={{textAlign: "center", padding: 10}}>
                            <span className="loading loading-dots loading-lg"></span>
                        </div>
                    )}
                    {(loading && !fData ) && (
                    <div style={{textAlign: "center", padding: 10}} className="mt-50">
                        <span className="loading loading-dots loading-lg"></span>
                        { progress>2 &&
                        <>
                            {/*<progress className="progress w-56" value={progress} max={progressMax}></progress>*/}
                            {/*<div>整理思路中 {(100 * progress / progressMax).toFixed(1)} %</div>*/}

                            {
                                Math.floor(remainingTime/60) === 0 ?
                                    <div>整理思路中 即将完成 </div> :
                                    <div>整理思路中 剩余约 {Math.floor(remainingTime/60)} 分钟 </div>

                            }
                        </>
                        }
                    </div>
                    )}
                    <div className="card-actions justify-end">
                    </div>
                </div>
            </div>

        </>
    );
};

export default History;